(() => {
const sectionRoot = document.querySelector('[id^="mn-collection-section-"][data-section-id]');
if (!sectionRoot || sectionRoot.dataset.mnBuilderReady === 'true') return;
sectionRoot.dataset.mnBuilderReady = 'true';
const builder = sectionRoot.querySelector('[data-mn-bundle-builder]');
const drawer = sectionRoot.querySelector('[data-mn-builder-drawer]');
const drawerContent = sectionRoot.querySelector('[data-mn-builder-drawer-content]');
const checkout = sectionRoot.querySelector('[data-mn-builder-checkout]');
const mobileDockSlots = sectionRoot.querySelector('[data-mn-mobile-dock-slots]');
const mobileDockStatus = sectionRoot.querySelector('[data-mn-mobile-dock-status]');
const mobilePackageCta = sectionRoot.querySelector('[data-mn-mobile-package-cta]');
const inlinePackage = sectionRoot.querySelector('[data-mn-inline-package]');
const inlinePackageWrap = sectionRoot.querySelector('[data-mn-inline-package-wrap]');
const desktopPackage = sectionRoot.querySelector('[data-mn-desktop-package]');
const desktopPackageCta = sectionRoot.querySelector('[data-mn-desktop-package-cta]');
const bottomInlinePackage = sectionRoot.querySelector('[data-mn-inline-package-bottom]');
const bottomInlinePackageWrap = sectionRoot.querySelector('[data-mn-inline-package-wrap-bottom]');
const bundleHero = sectionRoot.querySelector('.mn-bundle-hero');
const productsGrid = sectionRoot.querySelector('[data-mn-builder-products]');
const giftboxTemplate = sectionRoot.querySelector('[data-mn-bundle-giftbox-template]');
if (
!builder ||
!drawer ||
!drawerContent ||
!checkout
) return;

// Storleksguidens vanliga klicklyssnare i theme.liquid binds vid sidladdning.
// Main Collection laddar kedjelängdsfältet senare, så den behöver delegation.
drawerContent.addEventListener('click', (event) => {
  const trigger = event.target.closest('.mak__size-guide');
  if (!trigger || !drawerContent.contains(trigger)) return;
  event.preventDefault();
  event.stopPropagation();
  const modal = document.getElementById('makSizeGuideModal');
  if (!modal) return;
  // Flytta modalen ut ur sidinnehållets stacking context så den hamnar över drawern.
  if (modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }
  modal.style.zIndex = '1000004';
  modal.style.display = 'block';
}, true);

// Materialguiden laddas in som HTML i Main Collection-drawern.
// Skript i den inladdade PDP-snippeten körs inte automatiskt,
// så vi hanterar modalens klick direkt i den här sektionen.
drawerContent.addEventListener('click', (event) => {
  const openButton = event.target.closest('.mak__variants-main .mn-material-help__button');
  if (openButton) {
    event.preventDefault();
    event.stopPropagation();
    const picker = openButton.closest('.mak__variants-main');
    const dialog = picker?.querySelector('.mn-material-modal');
    if (dialog && !dialog.open) {
      dialog.showModal();
      openButton.setAttribute('aria-expanded', 'true');
    }
    return;
  }

  const closeButton = event.target.closest('.mak__variants-main .mn-material-modal__close');
  if (closeButton) {
    event.preventDefault();
    event.stopPropagation();
    closeButton.closest('dialog')?.close();
    return;
  }

  // Stäng även när kunden klickar på dialogens bakgrund.
  const dialog = event.target.closest('.mak__variants-main .mn-material-modal');
  if (dialog && event.target === dialog) {
    const rect = dialog.getBoundingClientRect();
    if (
      event.clientX < rect.left || event.clientX > rect.right ||
      event.clientY < rect.top || event.clientY > rect.bottom
    ) {
      dialog.close();
    }
  }
}, true);

// close fångas också vid Escape och klick på dialogens bakgrund.
drawerContent.addEventListener('close', (event) => {
  if (!event.target.matches('.mak__variants-main .mn-material-modal')) return;
  const picker = event.target.closest('.mak__variants-main');
  picker?.querySelector('.mn-material-help__button')?.setAttribute('aria-expanded', 'false');
}, true);

const bundleSize = Number(builder.dataset.bundleSize || 3);
const selectedItems = [];
const drawerCache = new Map();
const drawerRequestCache = new Map();
const drawerImageWarmCache = new Set();
const drawerImageWarmRequests = new Map();
let activeCard = null;
let drawerLoadToken = 0;
let savedBodyPadding = '';
let savedBodyScrollY = 0;
let bundleCartInProgress = false;
let currentGiftboxDrawer = null;
let giftboxBackdrop = null;

/* The mobile dock is a simple sticky bar; no drag or modal state. */

const syncDesktopGridGutters = () => {
  if (!productsGrid || !window.matchMedia('(min-width: 769px)').matches) {
    document.documentElement.style.removeProperty('--mn-desktop-grid-left');
    document.documentElement.style.removeProperty('--mn-desktop-grid-right');
    return;
  }
  const gridRect = productsGrid.getBoundingClientRect();
  document.documentElement.style.setProperty('--mn-desktop-grid-left', `${Math.max(0, Math.round(gridRect.left))}px`);
  document.documentElement.style.setProperty('--mn-desktop-grid-right', `${Math.max(0, Math.round(window.innerWidth - gridRect.right))}px`);
};

const getBundleStickyHeader = () => {
  const candidates = [...document.querySelectorAll(
    '.shopify-section-header-sticky, .section-header, sticky-header, [data-sticky-header], header'
  )].filter((element) => {
    const rect = element.getBoundingClientRect();
    const position = window.getComputedStyle(element).position;
    return rect.height > 0 && rect.bottom > 0 && rect.top <= 8 &&
      (position === 'sticky' || position === 'fixed');
  });
  return candidates.find((candidate) =>
    !candidates.some((other) => other !== candidate && other.contains(candidate))
  ) || candidates[0] || null;
};

const drawerSkeletonHtml = `
<div class="mn-builder-drawer__loading" aria-hidden="true">
<div class="mn-builder-drawer__skeleton-media"></div>
<div class="mn-builder-drawer__skeleton-body">
<div class="mn-builder-drawer__skeleton-line mn-builder-drawer__skeleton-line--title"></div>
<div class="mn-builder-drawer__skeleton-line mn-builder-drawer__skeleton-line--price"></div>
<div class="mn-builder-drawer__skeleton-line mn-builder-drawer__skeleton-line--label"></div>
<div class="mn-builder-drawer__skeleton-swatches">
<span class="mn-builder-drawer__skeleton-swatch"></span>
<span class="mn-builder-drawer__skeleton-swatch"></span>
<span class="mn-builder-drawer__skeleton-swatch"></span>
<span class="mn-builder-drawer__skeleton-swatch"></span>
</div>
<div class="mn-builder-drawer__skeleton-line mn-builder-drawer__skeleton-line--label"></div>
<div class="mn-builder-drawer__skeleton-field"></div>
</div>
</div>
`;
const escapeHtml = (value) =>
String(value || '').replace(/[&<>"']/g, (character) => ({
'&': '&amp;',
'<': '&lt;',
'>': '&gt;',
'"': '&quot;',
"'": '&#039;'
})[character]);
const formatTitle = (title) =>
String(title || '').trim().toLowerCase() === 'personligt namnhalsband'
? 'Namnhalsband'
: String(title || '').trim();
const getPremiumSlotTitle = (productRoot, variantId, variant = {}) => {
const masterSelect = productRoot?.querySelector(
'.mak__variants-main select[name="id"], select[name="id"]'
);
const selectedOption = masterSelect
? [...masterSelect.options].find(
(option) => String(option.value) === String(variantId)
) || masterSelect.selectedOptions?.[0]
: null;
const checkedValues = productRoot
? [...productRoot.querySelectorAll(
'.mak__variants-main .mak_variants_radio:checked, .mak__variants-main input[type="radio"]:checked'
)]
.map((input) => String(input.value || '').trim())
.filter(Boolean)
.join(' / ')
: '';
const premiumLabel = String(variant.premiumLabel || '')
.trim()
.toLowerCase();
const selectedVariantText = [
selectedOption?.dataset.name,
selectedOption?.textContent,
checkedValues,
variant.title,
variant.name,
variant.premiumLabel
]
.filter(Boolean)
.join(' ')
.toLowerCase();
if (
selectedVariantText.includes('18k Guld Vermeil') ||
premiumLabel === '18k Guld Vermeil'
) {
return '18k Guld Vermeil';
}
if (
selectedVariantText.includes('925 sterling silver') ||
premiumLabel === '925 sterling silver' ||
premiumLabel === 'sterling silver'
) {
return '925 Sterling silver';
}
return '';
};
const getFirstName = (properties) => {
const entry = Object.entries(properties || {}).find(([key]) =>
/namn|name/i.test(key)
);
return entry ? String(entry[1]).slice(0, 12) : '';
};

/* Sammanfattning i "Ditt paket":
   - Vanliga personliga smycken använder namnet från produktfältet.
   - Produkter utan namnfält (t.ex. bokstavshalsband) använder i stället
     den valda bokstavsvarianten.
   - Produktens valda material-/färgalternativ visas med exakt produktens egen varianttext. */
const hasBundleNameField = (productRoot) => Boolean(
productRoot?.querySelector(
[
'input[type="text"]',
'textarea',
'#maktextInput',
'#textInput',
'#your-name'
].join(', ')
)
);

const getSelectedBundleVariantParts = (productRoot, variantId, variant = {}) => {
if (!productRoot) return [];
const masterSelect = productRoot.querySelector(
'.mak__variants-main select[name="id"], select[name="id"]'
);
const selectedOption = masterSelect
? [...masterSelect.options].find(
(option) => String(option.value) === String(variantId)
) || masterSelect.selectedOptions?.[0]
: null;
const checkedValues = [...productRoot.querySelectorAll(
'.mak__variants-main .mak_variants_radio:checked, .mak__variants-main input[type="radio"]:checked'
)]
.map((input) => String(input.value || '').trim())
.filter(Boolean);
const combinedTitle = String(
selectedOption?.dataset.name ||
selectedOption?.textContent ||
variant.title ||
variant.name ||
''
).trim();
const titleParts = combinedTitle
.split(/\s*\/\s*|\s*[|·]\s*/g)
.map((part) => part.trim())
.filter(Boolean);
return [...new Set([...checkedValues, ...titleParts])];
};

/* Värdet som visas bredvid “Smycke 1 / Smycke 2” ska alltid komma från
   produktens eget val (t.ex. Guld, Silver, Roséguld). Vi standardiserar alltså
   inte texten till ett visst materialnamn. */
const isBundleMaterialValue = (value) =>
/guld|gold|silver|sterling|vermeil|pläter|plated|stål|steel|rose|rosé/i.test(
String(value || '')
);

const getBundleSelectedOption = (productRoot, variantId, variant = {}) => {
if (!productRoot) return '';

/* Först: hitta den riktiga variantgruppen som heter Material/Färg/Color osv
   och läs exakt det värde kunden valt i den gruppen. */
const optionGroups = [...productRoot.querySelectorAll(
'.mak__variants-main .option-selector, .mak__variants-main fieldset'
)];

for (const group of optionGroups) {
const groupLabel = String(
group.querySelector('legend, .option-selector__label, .label')?.textContent ||
group.getAttribute('data-option-name') ||
''
).trim();

if (!/material|färg|farg|colour|color|metall|metal|finish/i.test(groupLabel)) {
continue;
}

const checked = group.querySelector(
'.mak_variants_radio:checked, input[type="radio"]:checked'
);
if (checked) {
const value = String(checked.value || '').trim();
if (value) return value;
}

const select = group.querySelector('select');
if (select) {
const selected = select.selectedOptions?.[0];
const value = String(selected?.textContent || selected?.value || '').trim();
if (value) return value;
}
}

/* Fallback: använd variantens faktiska delar. På bokstavshalsband filtreras
   bokstaven bort så exempelvis “A / Guld” visar “Guld” bredvid Smycke 1. */
const parts = getSelectedBundleVariantParts(productRoot, variantId, variant)
.filter((value) => !/^default title$/i.test(String(value || '').trim()));

const nonLetterPart = parts.find(
(value) => !/^[A-ZÅÄÖ]$/i.test(String(value || '').trim())
);
if (nonLetterPart) return String(nonLetterPart).trim();

return '';
};

const getBundleVariantName = (productRoot, variantId, variant = {}) => {
const parts = getSelectedBundleVariantParts(productRoot, variantId, variant);
/* Bokstav först – stöd A–Z samt Å/Ä/Ö. */
const letter = parts.find((value) => /^[A-ZÅÄÖ]$/i.test(String(value).trim()));
if (letter) return String(letter).trim();

/* Fallback för andra produkter utan textfält: använd första variantdel som
   inte är material/färg och inte Shopifys "Default Title". */
const fallback = parts.find((value) => {
const clean = String(value || '').trim();
return clean &&
!isBundleMaterialValue(clean) &&
!/^default title$/i.test(clean);
});
return fallback ? String(fallback).trim() : '';
};
const readVariantMap = () => {
const json = drawerContent.querySelector('[data-mn-builder-variants]');
if (!json) return {};
try {
return JSON.parse(json.textContent);
} catch (error) {
return {};
}
};
const getCurrentVariantId = (productRoot) => {
if (!productRoot) return '';
const normalizeVariantTitle = (value) =>
String(value || '')
.trim()
.toLowerCase()
.replace(/\s*\/\s*/g, ' / ')
.replace(/\s+/g, ' ');
const selectedOptions = [...productRoot.querySelectorAll(
'.mak__variants-main .mak_variants_radio:checked, .mak__variants-main input[type="radio"]:checked'
)]
.map((input) => String(input.value || '').trim())
.filter(Boolean)
.join(' / ');
const masterSelect = productRoot.querySelector(
'.mak__variants-main select[name="id"], select[name="id"]'
);
if (masterSelect && selectedOptions) {
const normalizedSelection = normalizeVariantTitle(selectedOptions);
const matchedOption = [...masterSelect.options].find((option) => {
const optionName = option.dataset.name || option.textContent || '';
return normalizeVariantTitle(optionName) === normalizedSelection;
});
if (matchedOption) {
masterSelect.value = matchedOption.value;
return matchedOption.value;
}
}
return masterSelect?.value ||
productRoot.querySelector('input[name="id"]:checked, input[name="id"]')?.value ||
productRoot.querySelector('.mak_variants_radio:checked')?.dataset.variantId ||
'';
};
  // Håll materialkortens visade priser synkade med vald kedja och övriga val.
  // Inline-script i en klonad <template> / dynamiskt laddad drawer körs inte.
  const syncCollectionMaterialCardPrices = (variantsWrapper) => {
    const group = variantsWrapper?.querySelector('.option-selector--material-cards');
    if (!group) return;

    const materialIndex = Number(group.dataset.mnOptionIndex);
    if (!Number.isInteger(materialIndex)) return;

    const jsonEl = variantsWrapper.querySelector('[data-mn-drawer-variants]');
    let variants = [];
    let formatted = {};
    if (jsonEl) {
      try {
        const data = JSON.parse(jsonEl.textContent);
        if (Array.isArray(data.variants)) variants = data.variants;
        if (data.formatted && typeof data.formatted === 'object') formatted = data.formatted;
      } catch (error) {
        // Reservväg nedan: läs variantpriser från produktens select.
      }
    }

    if (!variants.length) {
      const select = variantsWrapper.querySelector('select[name="id"]');
      variants = Array.from(select?.options || []).map((option) => ({
        id: option.value,
        options: String(option.getAttribute('data-name') || '').split(/\s+\/\s+/),
        drawerPrice: option.getAttribute('data-price') || ''
      }));
    }

    const selected = {};
    variantsWrapper.querySelectorAll('fieldset[data-mn-option-index]').forEach((fieldset) => {
      const checked = fieldset.querySelector('.mak_variants_radio:checked');
      if (checked) selected[Number(fieldset.dataset.mnOptionIndex)] = checked.value;
    });

    group.querySelectorAll('[data-mn-material-value]').forEach((card) => {
      const priceEl = card.querySelector('[data-mn-material-price]');
      if (!priceEl) return;
      const candidates = variants.filter((variant) =>
        Array.isArray(variant.options) &&
        variant.options[materialIndex] === card.dataset.mnMaterialValue
      );
      const matched = candidates.find((variant) =>
        variant.options.every((value, index) =>
          index === materialIndex || selected[index] === undefined || selected[index] === value
        )
      ) || candidates[0];
      if (!matched) return;
      const price = formatted[String(matched.id)]?.price || matched.drawerPrice;
      if (price) priceEl.textContent = price;
    });
  };

const syncCollectionDiamondMaterial = (variantsWrapper) => {
const group = variantsWrapper?.querySelector('.option-selector--material-cards.mn-diamond-mode');
const chainGroup = variantsWrapper?.querySelector('.option-selector--chain-cards');
if (!group || !chainGroup) return;
const chain = chainGroup.querySelector('.mak_variants_radio:checked');
const diamond = chain?.value === 'Diamantkedja';
group.classList.toggle('mn-diamond-selected', diamond);
const current = group.querySelector('.mak_variants_radio:checked');
const material = current?.value || '';
let target = '';
if (diamond && material !== 'Guldplätering' && material !== 'Silverplätering') {
target = /guld|gold|vermeil/i.test(material) || !material ? 'Guldplätering' : 'Silverplätering';
} else if (!diamond && material === 'Silverplätering') {
target = 'Rostfritt stål';
}
if (target) {
const radio = [...group.querySelectorAll('.mak_variants_radio')].find(input => input.value === target);
if (radio) radio.checked = true;
}
};
const syncDrawerVariantState = (sourceElement = null) => {
const productRoot =
sourceElement?.closest?.('.mak__new__pdp-data') ||
drawerContent.querySelector('.mak__new__pdp-data');
if (!productRoot) return;
syncCollectionDiamondMaterial(productRoot.querySelector('.mak__variants-main'));
// Dynamiskt laddad Main Collection kör inte pdp-variants inline-script.
// Uppdatera därför materialkortens priser här vid varje variant-/kedjebyte.
syncCollectionMaterialCardPrices(productRoot.querySelector('.mak__variants-main'));
const variantId = getCurrentVariantId(productRoot);
const masterSelect = productRoot.querySelector(
'.mak__variants-main select[name="id"], select[name="id"]'
);
const selectedOption = masterSelect
? [...masterSelect.options].find(
(option) => String(option.value) === String(variantId)
) || masterSelect.selectedOptions?.[0]
: null;
if (masterSelect && selectedOption) {
masterSelect.value = selectedOption.value;
selectedOption.selected = true;
}
const variant = readVariantMap()[String(variantId)] || {};
const variantPrice =
selectedOption?.getAttribute('data-price') ||
variant.price ||
'';
if (variantPrice) {
productRoot.querySelectorAll(
[
'.mak_free-prices-normal > .price__default',
'.mak_free-prices-normal .price__current',
'[data-mn-builder-price]'
].join(', ')
).forEach((priceElement) => {
priceElement.textContent = variantPrice;
});
}
productRoot.querySelectorAll(
'button[default-variant-id], button[data-variant-id]'
).forEach((button) => {
if (button.hasAttribute('default-variant-id')) {
button.setAttribute('default-variant-id', variantId);
}
if (button.hasAttribute('data-variant-id')) {
button.setAttribute('data-variant-id', variantId);
}
});
};
const syncDrawerLayoutState = () => {
const productBottom = drawerContent.querySelector('.mak_pdp-btm-data');
if (!productBottom) return;
const hasTextField = Boolean(
productBottom.querySelector(
[
'input[type="text"]',
'textarea',
'#maktextInput',
'#textInput',
'#your-name'
].join(', ')
)
);
const chainText = [...productBottom.querySelectorAll(
'label, legend, [class*="chain"], [id*="chain"]'
)]
.map((element) => String(element.textContent || ''))
.join(' ');
const hasChainLength =
/kedjelängd|chain length/i.test(chainText) ||
Boolean(
productBottom.querySelector(
[
'[name*="Kedjelängd"]',
'[name*="kedjelängd"]',
'[name*="Chain length"]',
'[name*="chain_length"]'
].join(', ')
)
);
productBottom.classList.toggle(
'mn-drawer-text-only-no-chain',
hasTextField && !hasChainLength
);
};
const shouldOffsetBundleThumbnail = (option) => {
const normalized = String(option || '').trim().toLowerCase();
return (
normalized === '925 sterling silver' ||
normalized === '18k guld vermeil'
);
};

let lastRenderedPackageCount = selectedItems.length;

const renderBundlePackages = () => {
if (!inlinePackage && !bottomInlinePackage && !desktopPackage) return;

const selectedCount = selectedItems.length;
const poppedIndex =
selectedCount > lastRenderedPackageCount
? selectedCount - 1
: -1;

if (inlinePackageWrap) {
inlinePackageWrap.hidden = false;
}
if (bottomInlinePackageWrap) {
bottomInlinePackageWrap.hidden = false;
}

const rows = Array.from({ length: bundleSize }, (_, index) => {
const item = selectedItems[index];
const isGift = index === bundleSize - 1;
const slotLabel = isGift ? 'Gratis smycke' : `Smycke ${index + 1}`;
const giftBadge = isGift
? '<span class="mn-bundle-package__gift-badge">Kostnadsfritt</span>'
: '';

if (!item) {
const emptyText = isGift ? 'Välj ditt gratis smycke' : 'Välj smycke';
return `
<button
type="button"
class="mn-bundle-package__empty${isGift ? ' mn-bundle-package__empty--gift' : ''}"
data-mn-builder-scroll
>
<span class="mn-bundle-package__empty-plus" aria-hidden="true"></span>
<span class="mn-bundle-package__empty-copy">
<span class="mn-bundle-package__empty-text">${slotLabel} ${giftBadge}</span>
<span class="mn-bundle-package__empty-title">${emptyText}</span>
</span>
</button>
`;
}

const slotOption = item.option
? ` · ${escapeHtml(item.option)}`
: '';
const meta = item.property
? `${escapeHtml(item.propertyLabel || 'Namn')}: ${escapeHtml(item.property)}`
: '';

return `
<div class="mn-bundle-package__row${isGift ? ' mn-bundle-package__row--gift' : ''}${index === poppedIndex ? ' mn-bundle-package__row--pop' : ''}">
${item.image
? `<img class="mn-bundle-package__image${shouldOffsetBundleThumbnail(item.option) ? ' mn-bundle-package__image--premium-crop' : ''}" src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}">`
: '<div class="mn-bundle-package__image"></div>'}
<div class="mn-bundle-package__content">
<div class="mn-bundle-package__slot-label">${slotLabel}${slotOption} ${giftBadge}</div>
<div class="mn-bundle-package__product-title">${escapeHtml(item.title || item.slotTitle)}</div>
${meta ? `<div class="mn-bundle-package__meta">${meta}</div>` : ''}
</div>
<button
type="button"
class="mn-bundle-package__remove"
data-mn-builder-remove="${index}"
aria-label="Ta bort ${escapeHtml(slotLabel)}"
>×</button>
</div>
`;
}).join('');

const packageHtml = `
<div class="mn-bundle-package__head">
<div>
<div class="mn-bundle-package__title">Ditt paket</div>
<div class="mn-bundle-package__status">${selectedCount} av ${bundleSize} valda smycken</div>
</div>
</div>
<div class="mn-bundle-package__list">
${rows}
</div>
`;

if (inlinePackage) inlinePackage.innerHTML = packageHtml;
if (desktopPackage) desktopPackage.innerHTML = packageHtml;
if (desktopPackageCta) {
  const complete = selectedCount === bundleSize && !bundleCartInProgress;
  desktopPackageCta.disabled = !complete;
  desktopPackageCta.setAttribute('aria-disabled', String(!complete));
}
if (bottomInlinePackage) bottomInlinePackage.innerHTML = packageHtml;

lastRenderedPackageCount = selectedCount;
syncMobileDockVisibility();
};


const syncMobileDockVisibility = () => {
  if (!checkout) return;
  checkout.classList.remove('mn-bundle-checkout--desktop-scroll-hidden');
  if (!window.matchMedia('(max-width: 999px)').matches) {
    checkout.classList.add('mn-bundle-checkout--mobile-scroll-hidden');
    return;
  }
  if (!inlinePackageWrap) {
    checkout.classList.remove('mn-bundle-checkout--mobile-scroll-hidden');
    return;
  }
  const firstPackageSlot = inlinePackage?.querySelector('.mn-bundle-package__list > :nth-child(1)');
  const triggerRect = (firstPackageSlot || inlinePackageWrap).getBoundingClientRect();
  const stickyHeader = getBundleStickyHeader();
  const revealAt = stickyHeader ? Math.ceil(stickyHeader.getBoundingClientRect().bottom) : 0;
  const isHidden = checkout.classList.contains('mn-bundle-checkout--mobile-scroll-hidden');
  const shouldHide = isHidden
    ? triggerRect.bottom > revealAt
    : triggerRect.bottom > revealAt + 18;
  checkout.classList.toggle('mn-bundle-checkout--mobile-scroll-hidden', shouldHide);
};

/* Mobile-only dock: one independent slot per selected piece, with its own remove button.
   Uses the same selectedItems array as the desktop package and inline package. */
const renderMobileDock = () => {
if (!mobileDockSlots) return;
const selectedCount = selectedItems.length;
if (mobileDockStatus) {
if (selectedCount === 0) {
mobileDockStatus.innerHTML = '<strong>2 + 1 Gratis</strong> – Välj dina 3 smycken';
} else {
mobileDockStatus.innerHTML = `Du har valt <strong data-mn-mobile-dock-count style="font-weight: 700;">${selectedCount}</strong> av 3 smycken`;
}
}
if (mobilePackageCta) {
  const complete = selectedCount === bundleSize && !bundleCartInProgress;
  mobilePackageCta.disabled = !complete;
  mobilePackageCta.setAttribute('aria-disabled', String(!complete));
}
mobileDockSlots.innerHTML = Array.from({ length: bundleSize }, (_, index) => {
const item = selectedItems[index];
const label = index === bundleSize - 1 ? 'gratis smycke' : `smycke ${index + 1}`;
if (!item) {
return `<div class="mn-bundle-mobile-dock__slot">
<button type="button" class="mn-bundle-mobile-dock__add" data-mn-builder-scroll aria-label="Välj ${label}">
<span class="mn-bundle-mobile-dock__plus" aria-hidden="true">+</span>
</button>
</div>`;
}
return `<div class="mn-bundle-mobile-dock__slot mn-bundle-mobile-dock__slot--filled">
${item.image
? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title || label)}" loading="lazy">`
: '<span class="mn-bundle-mobile-dock__missing-image" aria-hidden="true"></span>'}
<button type="button" class="mn-bundle-mobile-dock__remove" data-mn-builder-remove="${index}" aria-label="Ta bort ${label}">×</button>
</div>`;
}).join('');
};

const updateCheckoutProgress = () => {
checkout.hidden = false;
renderMobileDock();
renderBundlePackages();
};
let dockVisibilityRaf = null;
const requestDockVisibilitySync = () => {
if (dockVisibilityRaf !== null) return;
dockVisibilityRaf = window.requestAnimationFrame(() => {
dockVisibilityRaf = null;
syncDesktopGridGutters();
syncMobileDockVisibility();
});
};

window.addEventListener('resize', () => {
if (inlinePackageWrap) {
inlinePackageWrap.hidden = false;
}
requestDockVisibilitySync();
});

window.addEventListener('scroll', () => {
requestDockVisibilitySync();
}, { passive: true });
window.addEventListener('load', requestDockVisibilitySync);

const updateSlots = () => {
updateCheckoutProgress();
};
const lockPage = () => {
const scrollbarWidth =
window.innerWidth - document.documentElement.clientWidth;
savedBodyPadding = document.body.style.paddingRight;
savedBodyScrollY = window.scrollY;
if (scrollbarWidth > 0) {
document.body.style.paddingRight = `${scrollbarWidth}px`;
}
document.body.style.position = 'fixed';
document.body.style.top = `-${savedBodyScrollY}px`;
document.body.style.right = '0';
document.body.style.left = '0';
document.body.style.width = '100%';
document.body.classList.add('mn-builder-drawer-open');
};
const unlockPage = () => {
const html = document.documentElement;
const body = document.body;
const previousHtmlScrollBehavior = html.style.scrollBehavior;
const previousBodyScrollBehavior = body.style.scrollBehavior;
const previousOverflowAnchor = html.style.overflowAnchor;
html.style.scrollBehavior = 'auto';
body.style.scrollBehavior = 'auto';
html.style.overflowAnchor = 'none';
body.classList.remove('mn-builder-drawer-open');
body.style.position = '';
body.style.top = '';
body.style.right = '';
body.style.left = '';
body.style.width = '';
body.style.paddingRight = savedBodyPadding;
window.scrollTo({
top: savedBodyScrollY,
left: 0,
behavior: 'auto'
});
window.requestAnimationFrame(() => {
html.style.scrollBehavior = previousHtmlScrollBehavior;
body.style.scrollBehavior = previousBodyScrollBehavior;
html.style.overflowAnchor = previousOverflowAnchor;
});
};
/* Main Collection laddar PDP-galleriet med innerHTML. Script-taggarna i
   pdp-gallery.liquid körs då inte. Därför sköter denna drawer uppspelning,
   förhandsbild, paus vid swipe och ljud lokalt utan att ändra Slick-layouten. */
const revealCollectionVideo = (video) => {
  const slide = video?.closest('.mn-pdp-video-slide');
  if (!slide || !slide.classList.contains('slick-current') ||
      slide.classList.contains('mn-pdp-video-ready')) return;
  const reveal = () => {
    if (slide.classList.contains('slick-current') &&
        !video.paused && video.readyState >= 2) {
      slide.classList.add('mn-pdp-video-ready');
    }
  };
  if (typeof video.requestVideoFrameCallback === 'function') {
    video.requestVideoFrameCallback(reveal);
  }
  /* Fallback när en dold video inte får en video-frame-callback i iOS. */
  window.setTimeout(reveal, 140);
};
const syncCollectionDrawerVideos = () => {
  const slider = drawerContent.querySelector('.product-main-slider');
  if (!slider || !drawer.classList.contains('is-open')) return;
  const activeSlide = slider.querySelector('.main-pdp.slick-current:not(.slick-cloned)') ||
    (!slider.classList.contains('slick-initialized')
      ? slider.querySelector('.main-pdp') : null);
  slider.querySelectorAll('.main-pdp video').forEach((video) => {
    const slide = video.closest('.main-pdp');
    const soundButton = slide?.querySelector('.mn-pdp-video-sound');
    if (slide !== activeSlide || slide.classList.contains('slick-cloned')) {
      if (!video.paused) video.pause();
      // Behåll senast renderade videobild även när sliden inte är aktiv.
      // Annars visar preview-overlayen sin thumbnail vid varje swipe.
      return;
    }
    video.muted = video.dataset.mnUserMuted !== 'false';
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    soundButton?.classList.toggle('is-unmuted', !video.muted);
    soundButton?.setAttribute('aria-label', video.muted ? 'Slå på ljud' : 'Stäng av ljud');
    if (video.paused || video.ended) {
      const playPromise = video.play();
      if (playPromise?.catch) playPromise.catch(() => {});
    }
    revealCollectionVideo(video);
  });
};
/* Delegated events överlever att olika produkter laddas i samma drawer. */
drawerContent.addEventListener('playing', (event) => {
  if (event.target.matches?.('.mn-pdp-video-slide video')) {
    revealCollectionVideo(event.target);
  }
}, true);
drawerContent.addEventListener('loadeddata', (event) => {
  if (event.target.matches?.('.mn-pdp-video-slide video')) {
    revealCollectionVideo(event.target);
  }
}, true);
drawerContent.addEventListener('click', (event) => {
  const soundButton = event.target.closest('.mn-pdp-video-sound');
  if (soundButton && drawerContent.contains(soundButton)) {
    const video = soundButton.closest('.main-pdp')?.querySelector('video');
    if (!video) return;
    event.preventDefault();
    event.stopPropagation();
    video.muted = !video.muted;
    video.dataset.mnUserMuted = video.muted ? 'true' : 'false';
    soundButton.classList.toggle('is-unmuted', !video.muted);
    soundButton.setAttribute('aria-label', video.muted ? 'Slå på ljud' : 'Stäng av ljud');
    if (video.paused) {
      const playPromise = video.play();
      if (playPromise?.catch) playPromise.catch(() => {});
    }
    return;
  }
  const video = event.target.closest('.mn-pdp-video-slide.slick-current video');
  if (!video || !drawerContent.contains(video)) return;
  event.preventDefault();
  event.stopPropagation();
  if (video.paused || video.ended) {
    const playPromise = video.play();
    if (playPromise?.catch) playPromise.catch(() => {});
  } else {
    video.pause();
  }
});
const initGallery = () => {
if (!window.jQuery || !window.jQuery.fn?.slick) return;
const $ = window.jQuery;
const mainSlider = drawerContent.querySelector('.product-main-slider');
const navSlider = drawerContent.querySelector('.product-nav-slider');
if (!mainSlider) return;

/* Samma vertikala swipe-spärr som vanliga Anpassa-drawern:
   översta 90 % av bildytan tillåter bildswipe men inte vertikal scroll;
   nedersta 10 % tillåter vanlig vertikal scroll. */
if (!mainSlider.dataset.mnTouchZonesReady) {
  mainSlider.dataset.mnTouchZonesReady = 'true';
  let blockVerticalScroll = false;
  mainSlider.addEventListener('touchstart', (event) => {
    blockVerticalScroll = false;
    if (window.innerWidth >= 1000 || event.touches.length !== 1) return;
    const bounds = mainSlider.querySelector('.slick-list')?.getBoundingClientRect();
    if (!bounds) return;
    const y = event.touches[0].clientY;
    blockVerticalScroll = y >= bounds.top && y < bounds.top + bounds.height * 0.90;
  }, { passive: true });
  mainSlider.addEventListener('touchmove', (event) => {
    if (blockVerticalScroll && event.cancelable) event.preventDefault();
  }, { capture: true, passive: false });
  ['touchend', 'touchcancel'].forEach((type) => {
    mainSlider.addEventListener(type, () => { blockVerticalScroll = false; }, { passive: true });
  });
}

/* Desktop two-column drawer:
   Give Slick a guaranteed non-zero pixel width before it calculates slides.
   The carousel itself stays identical to mobile. */
if (window.matchMedia('(min-width: 1000px)').matches) {
const mediaColumn = drawerContent.querySelector('.mak_pdp-top_data');
const drawerPanel = drawer.querySelector('.mn-builder-drawer__panel');

let galleryWidth = Math.round(
mediaColumn?.getBoundingClientRect().width || 0
);

if (galleryWidth < 100 && drawerPanel) {
galleryWidth = Math.round(drawerPanel.getBoundingClientRect().width * 0.57);
}

if (galleryWidth > 0) {
[
mediaColumn,
drawerContent.querySelector('.new-slider'),
drawerContent.querySelector('.slider-main-pdp'),
drawerContent.querySelector('.banner-images-pdp'),
mainSlider
].forEach((element) => {
if (!element) return;
element.style.width = `${galleryWidth}px`;
element.style.maxWidth = `${galleryWidth}px`;
});
}
}
if (!mainSlider.id) {
mainSlider.id = `mn-builder-main-${activeCard?.dataset.mnBuilderCard || 'product'}`;
}
if (navSlider && !navSlider.id) {
navSlider.id = `mn-builder-nav-${activeCard?.dataset.mnBuilderCard || 'product'}`;
}
const $main = $(mainSlider);
const $nav = navSlider ? $(navSlider) : null;
if ($main.hasClass('slick-initialized')) {
$main.slick('unslick');
}
if ($nav?.hasClass('slick-initialized')) {
$nav.slick('unslick');
}
const mainSettings = {
slidesToShow: window.matchMedia('(min-width: 1000px)').matches ? 1.09 : 1.07,
variableWidth: window.matchMedia('(max-width: 768px)').matches,
slidesToScroll: 1,
speed: 300,
infinite: false,
arrows: true,
dots: false,
adaptiveHeight: false,
swipeToSlide: true,
/* Lättare horisontell swipe på mobil, samma känslighet som vanliga Anpassa-drawern. */
touchThreshold: window.innerWidth < 1000 ? 15 : 5
};
if (navSlider?.id) {
mainSettings.asNavFor = `#${navSlider.id}`;
}
$main.slick(mainSettings);

/* Behåll mobilens 1 px- och sista-bildskorrigering som i vanliga Anpassa-drawern.
   På desktop högerjusterar Slick automatiskt sista bilden (1.09 slidesToShow).
   getLeft används även efter slickFilter när bara vald materialgrupp visas. */
const mainSlick = $main.slick('getSlick');
if (mainSlick && !mainSlick.mnDrawerLastSlideAligned) {
  mainSlick.mnDrawerLastSlideAligned = true;
  const originalGetLeft = mainSlick.getLeft;
  mainSlick.getLeft = function(slideIndex) {
    const defaultLeft = originalGetLeft.call(this, slideIndex);
    const mobileVariableGallery =
      window.matchMedia('(max-width: 768px)').matches &&
      this.options?.variableWidth &&
      this.options?.infinite === false &&
      !this.options?.centerMode &&
      !this.options?.vertical;
    if (mobileVariableGallery && this.slideCount > 1 &&
        slideIndex === this.slideCount - 1 && Number.isFinite(defaultLeft)) {
      const lastSlide = this.$slideTrack?.children('.slick-slide').eq(slideIndex)?.[0];
      const list = this.$list?.[0];
      if (lastSlide && list) {
        const extraSpace = list.getBoundingClientRect().width -
          lastSlide.getBoundingClientRect().width;
        if (Number.isFinite(extraSpace) && extraSpace > 0) {
          return defaultLeft + extraSpace;
        }
      }
    }
    // Andra bilden 1 px åt vänster. Om den också är sista gäller högerkanten ovan.
    if (mobileVariableGallery && slideIndex === 1 && Number.isFinite(defaultLeft)) {
      return defaultLeft - 1;
    }
    return defaultLeft;
  };
}
$main.off('.mnBuilderVideo');
$main.on('beforeChange.mnBuilderVideo', () => {
  mainSlider.querySelectorAll('.main-pdp video').forEach((video) => {
    if (!video.paused) video.pause();
  });
});
$main.on('afterChange.mnBuilderVideo reInit.mnBuilderVideo', () => {
  syncCollectionDrawerVideos();
});

/* Desktop: horisontell tvåfingers-scroll på trackpad byter exakt EN bild.
   Momentum från samma swipe ignoreras, men en ny tydlig swipe kan starta direkt
   utan att muspekaren behöver flyttas. */
$main.off('wheel.mnBuilderImages');

if (window.matchMedia('(min-width: 1000px)').matches) {
let horizontalLocked = false;
let horizontalAccumulator = 0;
let horizontalDirection = 0;
let lastHorizontalEventAt = 0;
let lastHorizontalAbsDelta = 0;
let lastTriggerAt = 0;

$main.on('wheel.mnBuilderImages', (event) => {
if (!$main.hasClass('slick-initialized')) return;

const originalEvent = event.originalEvent || event;
const deltaX = Number(originalEvent.deltaX || 0);
const deltaY = Number(originalEvent.deltaY || 0);
const absX = Math.abs(deltaX);

/* Bara tydligt horisontella trackpad-gester.
   Vertikal scroll och vanligt mushjul påverkar inte bildkarusellen. */
if (
absX < 2 ||
absX <= Math.abs(deltaY)
) {
return;
}

/* Blockera alltid horisontell browser-navigation över bildytan,
   även när karusellen står på första/sista bilden. */
event.preventDefault();
event.stopPropagation();

const now = performance.now();
const direction = deltaX > 0 ? 1 : -1;
const sinceLastEvent = now - lastHorizontalEventAt;
const sinceTrigger = now - lastTriggerAt;

/* När en bild redan bytts är resten av samma trackpad-momentum låst.
   Lås upp endast när:
   1) det varit en tydlig paus mellan events, ELLER
   2) efter en kort säkerhetsperiod kommer en ny stark impuls
      (typiskt ett nytt tvåfingers-swipe medan gammal inertia klingar av). */
if (horizontalLocked) {
const clearNewGestureGap = sinceLastEvent > 140;
const newImpulse =
sinceTrigger > 260 &&
absX >= 10 &&
absX > Math.max(10, lastHorizontalAbsDelta * 1.75);

if (clearNewGestureGap || newImpulse) {
horizontalLocked = false;
horizontalAccumulator = 0;
horizontalDirection = 0;
} else {
lastHorizontalEventAt = now;
lastHorizontalAbsDelta = absX;
return;
}
}

if (horizontalDirection && horizontalDirection !== direction) {
horizontalAccumulator = 0;
}
horizontalDirection = direction;
horizontalAccumulator += deltaX;

lastHorizontalEventAt = now;
lastHorizontalAbsDelta = absX;

/* Ett avsiktligt swipe måste nå denna tröskel innan bildbyte. */
if (Math.abs(horizontalAccumulator) < 24) return;

horizontalAccumulator = 0;
horizontalLocked = true;
lastTriggerAt = now;

const slick = $main.slick('getSlick');
const currentSlide = $main.slick('slickCurrentSlide');
const lastSlide = Math.max(0, slick.slideCount - 1);

if (direction > 0 && currentSlide < lastSlide) {
$main.slick('slickNext');
} else if (direction < 0 && currentSlide > 0) {
$main.slick('slickPrev');
}
});
}

if ($nav) {
const navSettings = {
slidesToShow: 4,
slidesToScroll: 1,
infinite: false,
arrows: false,
dots: false,
focusOnSelect: true
};
if (mainSlider.id) {
navSettings.asNavFor = `#${mainSlider.id}`;
}
$nav.slick(navSettings);
}
const refresh = () => {
if ($main.hasClass('slick-initialized')) {
$main.slick('setPosition');
}
if ($nav?.hasClass('slick-initialized')) {
$nav.slick('setPosition');
}
};
requestAnimationFrame(() => {
requestAnimationFrame(refresh);
});
window.setTimeout(refresh, 80);
window.setTimeout(refresh, 250);
window.setTimeout(refresh, 420);
if (mainSlider.mnDrawerResizeObserver) {
mainSlider.mnDrawerResizeObserver.disconnect();
}
if ('ResizeObserver' in window) {
const panel = drawer.querySelector('.mn-builder-drawer__panel');
mainSlider.mnDrawerResizeObserver = new ResizeObserver(() => {
refresh();
});
if (panel) {
mainSlider.mnDrawerResizeObserver.observe(panel);
}
}
};
const getVariantInputFromSource = (sourceElement, productRoot) => {
if (!sourceElement || !productRoot) return null;
if (sourceElement.matches?.('input.mak_variants_radio, input[type="radio"]')) {
return sourceElement;
}
const label = sourceElement.closest?.('label[for], .opt-label[for]');
const inputId = label?.getAttribute('for');
if (inputId) {
return [...productRoot.querySelectorAll('input')].find(
(input) => input.id === inputId
) || null;
}
return null;
};
/* Samma mediagruppering som Main Product / vanliga Anpassa-drawern:
   bara produkten med fem material och Diamantkedja. Vanliga produkter ska
   alltid behålla samtliga bilder i galleriet. */
const normalizeCollectionSlickIndexes = ($slider) => {
  if (!$slider?.hasClass('slick-initialized')) return;
  $slider.slick('getSlick')?.$slides?.each((index, slide) => {
    slide.setAttribute('data-slick-index', index);
  });
};
const getCollectionSilverMediaGroups = (mainSlider, material, imageId) => {
  const groups = [material, '__all__'];
  if (material !== 'Silverplätering') return groups;
  const slides = [...mainSlider.querySelectorAll('.main-pdp:not(.slick-cloned)')];
  const available = new Set(slides.map((slide) =>
    slide.getAttribute('data-media-material') || ''
  ));
  const matchingSlide = imageId ? slides.find((slide) =>
    slide.getAttribute('data-image-id') === String(imageId)
  ) : null;
  const imageGroup = matchingSlide?.getAttribute('data-media-material') || '';
  if (/silver|sterling|925|rostfritt|stål|stal|steel/i.test(imageGroup)) {
    groups.push(imageGroup);
  }
  // Silverplätering delar ibland bilder med ett annat silvermaterial.
  if (groups.every((group) => group === '__all__' || !available.has(group))) {
    const fallback = ['Rostfritt stål', '925 Sterling Silver', 'Sterling Silver', 'Silver'];
    const selected = fallback.find((group) => available.has(group)) ||
      [...available].find((group) =>
        /silver|sterling|925|rostfritt|stål|stal|steel/i.test(group)
      );
    if (selected) groups.push(selected);
  }
  return groups;
};
const goToSelectedVariantImage = (sourceElement = null) => {
  if (!window.jQuery?.fn?.slick) return;
  const productRoot =
    sourceElement?.closest?.('.mak__new__pdp-data') ||
    drawerContent.querySelector('.mak__new__pdp-data');
  const mainSlider = productRoot?.querySelector('.product-main-slider');
  const navSlider = productRoot?.querySelector('.product-nav-slider');
  if (!productRoot || !mainSlider) return;
  const $main = window.jQuery(mainSlider);
  if (!$main.hasClass('slick-initialized')) return;
  const $nav = navSlider ? window.jQuery(navSlider) : null;
  const clickedInput = getVariantInputFromSource(sourceElement, productRoot);
  const variantId = getCurrentVariantId(productRoot);
  const variant = readVariantMap()[String(variantId)] || {};
  const masterSelect = productRoot.querySelector('.mak__variants-main select[name="id"]');
  const selectedOption = masterSelect?.selectedOptions?.[0];
  const fiveMaterialGroup = productRoot.querySelector(
    '.option-selector--material-cards.mn-diamond-mode'
  );
  // Behåll exakt det gamla bildvalsflödet för vanliga produkter.
  // För femmaterialssmycket behövs hela variantens bild-id efter kedjebyte.
  const imageId = fiveMaterialGroup ? (
    selectedOption?.getAttribute('data-image-id') ||
    variant.mediaId || variant.imageId ||
    clickedInput?.getAttribute('data-image-id') ||
    clickedInput?.dataset?.imageId || ''
  ) : (
    clickedInput?.getAttribute('data-image-id') ||
    clickedInput?.dataset?.imageId ||
    variant.mediaId || variant.imageId || ''
  );
  const material = fiveMaterialGroup?.querySelector('.mak_variants_radio:checked')?.value || '';
  let materialChanged = false;
  if (fiveMaterialGroup && material &&
      productRoot.dataset.mnCollectionGalleryMaterial !== material) {
    $main.slick('slickUnfilter');
    normalizeCollectionSlickIndexes($main);
    if ($nav?.hasClass('slick-initialized')) {
      $nav.slick('slickUnfilter');
      normalizeCollectionSlickIndexes($nav);
    }

    const groups = getCollectionSilverMediaGroups(mainSlider, material, imageId);
    const hasMatchingMedia = [...mainSlider.querySelectorAll('.main-pdp:not(.slick-cloned)')]
      .some((slide) => groups.includes(slide.getAttribute('data-media-material') || ''));

    // Saknas märkta bilder för en variant: behåll alla hellre än att visa en tom slider.
    if (hasMatchingMedia) {
      const filter = ($slider) => {
        if (!$slider?.hasClass('slick-initialized')) return;
        $slider.slick('slickFilter', function() {
          return groups.includes(this.getAttribute('data-media-material') || '');
        });
        normalizeCollectionSlickIndexes($slider);
        $slider.slick('setPosition');
      };
      filter($main);
      filter($nav);
    }
    productRoot.dataset.mnCollectionGalleryMaterial = material;
    materialChanged = true;
  }

  if (!imageId && !fiveMaterialGroup) return;
  const syncVisibleImage = () => {
    if (!productRoot.isConnected || !$main.hasClass('slick-initialized')) return;
    const goTo = ($slider) => {
      if (!$slider?.hasClass('slick-initialized')) return;
      const slides = $slider.slick('getSlick')?.$slides?.toArray() || [];
      const index = imageId ? slides.findIndex((slide) =>
        String(slide.getAttribute('data-image-id') ||
          slide.getAttribute('data-media-id') || '') === String(imageId)
      ) : -1;
      if (index < 0 && !fiveMaterialGroup) return;
      // Vid byte av grupp ska alltid en synlig bild väljas.
      if (index >= 0 || materialChanged) {
        $slider.slick('slickGoTo', index >= 0 ? index : 0, true);
        $slider.slick('setPosition');
      }
    };
    goTo($main);
    goTo($nav);
    syncCollectionDrawerVideos();
  };
  syncVisibleImage();
  // Slick behöver två frames för rätt position efter första filterbytet på mobil.
  if (materialChanged && window.matchMedia('(max-width: 999px)').matches) {
    requestAnimationFrame(() => requestAnimationFrame(syncVisibleImage));
  }
};
const initVariantGallerySync = () => {
if (drawerContent.dataset.mnVariantGalleryReady === 'true') {
return;
}
drawerContent.dataset.mnVariantGalleryReady = 'true';
drawerContent.addEventListener('change', (event) => {
if (!event.target.matches(
[
'.mak__variants-main .mak_variants_radio',
'.mak__variants-main input[type="radio"]',
'.mak__variants-main select[name="id"]'
].join(', ')
)) {
return;
}
syncDrawerVariantState(event.target);
if (event.target.matches('input[type="radio"]')) {
goToSelectedVariantImage(event.target);
window.setTimeout(() => {
syncDrawerVariantState(event.target);
goToSelectedVariantImage(event.target);
}, 40);
}
}, true);
drawerContent.addEventListener('click', (event) => {
const label = event.target.closest(
'.mak__variants-main label[for], .mak__variants-main .opt-label[for]'
);
if (!label) return;
const productRoot = label.closest('.mak__new__pdp-data');
const input = getVariantInputFromSource(label, productRoot);
if (!input) return;
window.setTimeout(() => {
syncDrawerVariantState(input);
goToSelectedVariantImage(input);
}, 0);
window.setTimeout(() => {
syncDrawerVariantState(input);
}, 40);
}, true);
};
const initCollectionFontPreview = () => {
const fontRoots = drawerContent.querySelectorAll(
'.mak-input-wrapper.mak-font-selector-normal'
);
const getMaterialValue = (productRoot) => {
const variants = productRoot.querySelector('.mak__variants-main');
if (!variants) return '';
const selectedMaterial = variants.querySelector(
'.option-selector--material-cards .mak_variants_radio:checked, .mak_variants_radio.pdp-farg:checked'
);
if (selectedMaterial) return String(selectedMaterial.value || '').trim();
const checkedValues = [...variants.querySelectorAll('.mak_variants_radio:checked')]
.map((input) => String(input.value || '').trim());
const materialValue = checkedValues.find((value) =>
/guld|gold|silver|sterling|vermeil|pläter|plated|925|rostfritt|stål|stal|stainless|steel/i.test(value)
);
if (materialValue) return materialValue;
const activeSwatch = variants.querySelector(
'.option-selector--material-cards .opt-label.active, .option-selector--material-cards .opt-label.is-active, .option-selector--material-cards .opt-label[aria-selected="true"], .option-selector--material-cards .opt-label[aria-checked="true"]'
);
return activeSwatch
? String(
activeSwatch.dataset.mnMaterialValue ||
activeSwatch.dataset.swatch ||
activeSwatch.dataset.value ||
activeSwatch.textContent ||
''
).trim()
: '';
};
const applyMaterial = (preview, materialValue) => {
const material = String(materialValue || '').toLowerCase();
const isSilver = /vitguld|white\s*gold/i.test(material) || (
!/guld|gold|vermeil|pläter|plated/i.test(material) &&
/silver|sterling|925|rostfritt|stål|stal|stainless|steel|sliver/i.test(material)
);
const gradient = isSilver
? 'linear-gradient(180deg, #a9a9a9 0%, #eeeeee 48%, #a9a9a9 100%)'
: 'linear-gradient(180deg, #b99743 0%, #f1ddb0 48%, #b99743 100%)';
preview.classList.toggle('mar-silver', isSilver);
preview.classList.toggle('mar-sliver', isSilver);
preview.classList.toggle('mar-gold', !isSilver);
preview.dataset.material = isSilver ? 'mar-silver' : 'gold';
preview.style.setProperty('background-image', gradient, 'important');
preview.style.setProperty('background-clip', 'text', 'important');
preview.style.setProperty('-webkit-background-clip', 'text', 'important');
preview.style.setProperty('color', 'transparent', 'important');
preview.style.setProperty('-webkit-text-fill-color', 'transparent', 'important');
preview.style.setProperty('-webkit-text-stroke-width', '0.35px', 'important');
};
const syncFontRoot = (fontRoot) => {
const productRoot =
fontRoot.closest('.mak__new__pdp-data') || drawerContent;
let selectedButton = fontRoot.querySelector(
'.mak-button-wrapper-brd.mak-selected, .button-wrapper-brd.selected'
);
if (!selectedButton) {
selectedButton = fontRoot.querySelector(
'.mak-button-wrapper-brd, .button-wrapper-brd'
);
selectedButton?.classList.add(
selectedButton.classList.contains('mak-button-wrapper-brd')
? 'mak-selected'
: 'selected'
);
}
const selectedFont = selectedButton?.querySelector('.mak-btn-i, .btn-i');
const fontFamily =
selectedFont?.getAttribute('value') ||
selectedFont?.dataset.font ||
'Laura';
const fontCode = selectedFont?.dataset.name || '';
const hiddenFont = fontRoot.querySelector('#fontSelected');
if (hiddenFont && fontCode) hiddenFont.value = fontCode;
const materialValue = getMaterialValue(productRoot);

/* Flera namn: markupen återanvänder samma ID för varje rad.
   Uppdatera varje inputs egen preview/hidden field lokalt i raden. */
const multipleNameRows = fontRoot.querySelectorAll(
'.wrapper-1 > .mak-iec-input-wrapper'
);
if (multipleNameRows.length) {
multipleNameRows.forEach((row) => {
const nameInput = row.querySelector('input#maktextInput');
if (!nameInput) return;
const value = String(nameInput.value || '');
const hiddenName = row.querySelector('input#maktextInput-val');
if (hiddenName) hiddenName.value = value;
const counter = row.querySelector('#mak_font-limit');
if (counter) {
const maxLength = nameInput.maxLength > 0 ? nameInput.maxLength : 6;
counter.textContent = `${value.length}/${maxLength}`;
}
const preview = row.querySelector(
'#makmyHeading, #myHeading, .inner-fontpreview-wrapper'
);
const inputField = nameInput.closest(
'.mak-iec-inner-text-wrapper, .iec-inner-text-wrapper, .input-field'
);
const previewWrap = preview?.closest(
'.mak-fontPreview_FontPreview__4SFiv, .fontPreview_FontPreview__4SFiv, .fontPreview'
);
if (preview) {
preview.textContent = value;
preview.style.fontFamily = `"${fontFamily}"`;
applyMaterial(preview, materialValue);
}
inputField?.classList.toggle('mak-partial-width', Boolean(value));
inputField?.classList.toggle('partial-width', Boolean(value));
inputField?.classList.toggle('mak-full-width', !value);
previewWrap?.classList.toggle('mak-partial-width', Boolean(value));
previewWrap?.classList.toggle('partial-width', Boolean(value));
});
return;
}

/* Ett namn: behåll befintlig funktion för den vanliga produktväljaren. */
const nameInput = fontRoot.querySelector(
'#personalizationInput, #maktextInput, #textInput'
);
const preview = fontRoot.querySelector(
'#makmyHeading, #myHeading, .inner-fontpreview-wrapper'
);
if (!nameInput || !preview) return;
const value = String(nameInput.value || '').trim();
const hiddenName = fontRoot.querySelector(
'#maktextInput-val, #textInput-val'
);
const inputField = nameInput.closest(
'.mak-iec-inner-text-wrapper, .iec-inner-text-wrapper, .input-field'
);
const previewWrap = preview.closest(
'.mak-fontPreview_FontPreview__4SFiv, .fontPreview_FontPreview__4SFiv, .fontPreview'
);
preview.textContent = value;
preview.style.fontFamily = `"${fontFamily}"`;
if (hiddenName) hiddenName.value = value;
inputField?.classList.toggle('mak-partial-width', Boolean(value));
inputField?.classList.toggle('partial-width', Boolean(value));
previewWrap?.classList.toggle('mak-partial-width', Boolean(value));
previewWrap?.classList.toggle('partial-width', Boolean(value));
applyMaterial(preview, materialValue);
};
const syncAllFontPreviews = () => {
drawerContent.querySelectorAll(
'.mak-input-wrapper.mak-font-selector-normal'
).forEach(syncFontRoot);
};
fontRoots.forEach((fontRoot) => {
if (fontRoot.dataset.mnFontPreviewReady === 'true') {
syncFontRoot(fontRoot);
return;
}
fontRoot.dataset.mnFontPreviewReady = 'true';
fontRoot.addEventListener('input', (event) => {
if (!event.target.matches('#personalizationInput, #maktextInput, #textInput')) {
return;
}
syncFontRoot(fontRoot);
});
fontRoot.addEventListener('click', (event) => {
if (event.target.closest('.multi_input_btns .add-another-name, .multi_input_btns .add-remove-name')) {
window.setTimeout(() => syncFontRoot(fontRoot), 0);
return;
}
const fontButton = event.target.closest(
'.mak-button-wrapper-brd, .button-wrapper-brd'
);
if (!fontButton || !fontRoot.contains(fontButton)) return;
fontRoot.querySelectorAll(
'.mak-button-wrapper-brd, .button-wrapper-brd'
).forEach((button) => {
button.classList.remove('mak-selected', 'selected');
});
fontButton.classList.add(
fontButton.classList.contains('mak-button-wrapper-brd')
? 'mak-selected'
: 'selected'
);
syncFontRoot(fontRoot);
});
syncFontRoot(fontRoot);
});
if (drawerContent.dataset.mnMaterialPreviewReady !== 'true') {
drawerContent.dataset.mnMaterialPreviewReady = 'true';
drawerContent.addEventListener('change', (event) => {
if (
event.target.matches(
'.mak_variants_radio, .mak__variants-main input[type="radio"], .mak__variants-main select'
)
) {
window.setTimeout(syncAllFontPreviews, 0);
window.setTimeout(syncAllFontPreviews, 60);
}
}, true);
drawerContent.addEventListener('click', (event) => {
if (
event.target.closest(
'.opt-label, .mak__variants-main label, .mak__variants-main input'
)
) {
window.setTimeout(syncAllFontPreviews, 0);
window.setTimeout(syncAllFontPreviews, 60);
}
}, true);
}
window.setTimeout(syncAllFontPreviews, 0);
window.setTimeout(syncAllFontPreviews, 120);
};
/* Ett namn: "Namn". Fler namn: "Namn 1", "Namn 2" osv. Endast collection-drawern. */
const syncCollectionFirstNameLabel = () => {
  drawerContent.querySelectorAll(
    '.mak__variants-main .multi_input_btns[data-index]'
  ).forEach((controls) => {
    const nameRoot = controls.closest('.mak-input-wrapper.mak-font-selector-normal');
    const firstLabel = nameRoot?.querySelector(
      '.wrapper-1 .mak-iec-input-wrapper[data-show="1"] .mak-iec-inner-text-wrapper > label.label'
    );
    if (!firstLabel) return;
    const nameCount = Number.parseInt(controls.dataset.index, 10) || 1;
    firstLabel.textContent = nameCount > 1 ? 'Namn 1' : 'Namn';
  });
};
const initCollectionNameLabels = () => {
  syncCollectionFirstNameLabel();
  if (drawerContent.dataset.mnCollectionNameLabelsReady === 'true') return;
  drawerContent.dataset.mnCollectionNameLabelsReady = 'true';
  drawerContent.addEventListener('click', (event) => {
    if (!event.target.closest(
      '.multi_input_btns .add-another-name, .multi_input_btns .add-remove-name'
    )) return;
    /* Originalets AddAnotherName/RemoveName har då hunnit uppdatera data-index. */
    window.setTimeout(syncCollectionFirstNameLabel, 0);
  });
};
const initExistingCustomisation = () => {
if (typeof window.makClearFreeProductDrawerInputs === 'function') {
window.makClearFreeProductDrawerInputs(drawer);
}
if (typeof window.MainProductData2 === 'function') {
window.MainProductData2();
}
if (typeof window.textLimit === 'function') {
window.textLimit();
}
initCollectionNameCounters();
initCollectionFontPreview();
initCollectionNameLabels();
const drawerPanel = drawer.querySelector('.mn-builder-drawer__panel');
drawerPanel?.getBoundingClientRect();
initGallery();

/* När drawer-sliden är färdig: be samma Slick-instans mäta om sig.
   Vi unslickar INTE igen, så carousel-state och bilder behålls. */
if (window.matchMedia('(min-width: 1000px)').matches) {
window.setTimeout(() => {
const $main = window.jQuery?.(drawerContent.querySelector('.product-main-slider'));
const $nav = window.jQuery?.(drawerContent.querySelector('.product-nav-slider'));

if ($main?.hasClass('slick-initialized')) {
$main.slick('setPosition');
}
if ($nav?.hasClass('slick-initialized')) {
$nav.slick('setPosition');
}
}, 500);
}

initVariantGallerySync();
syncDrawerVariantState();
/* Filtrera bara femmaterialssmycket direkt när drawern öppnas.
   Övriga produkters initiala bildval förblir oförändrat. */
if (drawerContent.querySelector('.option-selector--material-cards.mn-diamond-mode')) {
  goToSelectedVariantImage();
}
syncDrawerLayoutState();
/* Spela bara den valda videon och visa den först när den är redo. */
syncCollectionDrawerVideos();
window.requestAnimationFrame(syncCollectionDrawerVideos);
window.setTimeout(syncCollectionDrawerVideos, 150);
};
const ensureGiftboxBackdrop = () => {
if (giftboxBackdrop && document.body.contains(giftboxBackdrop)) {
return giftboxBackdrop;
}
giftboxBackdrop = document.createElement('button');
giftboxBackdrop.type = 'button';
giftboxBackdrop.className = 'mn-builder-giftbox-backdrop';
giftboxBackdrop.setAttribute('aria-label', 'Stäng presentförpackning');
document.body.appendChild(giftboxBackdrop);
giftboxBackdrop.addEventListener('click', (event) => {
event.preventDefault();
rollbackThirdSelection();
});
return giftboxBackdrop;
};

const removePortaledGiftbox = () => {
if (currentGiftboxDrawer && document.body.contains(currentGiftboxDrawer)) {
currentGiftboxDrawer.remove();
}
currentGiftboxDrawer = null;
document.body.classList.remove('mn-builder-giftbox-open');
if (giftboxBackdrop) {
giftboxBackdrop.classList.remove('is-open');
}
};

const portalGiftboxDrawer = (giftboxDrawer) => {
if (!giftboxDrawer) return null;
removePortaledGiftbox();
giftboxDrawer.setAttribute('data-mn-builder-giftbox', '');
giftboxDrawer.setAttribute('aria-hidden', 'true');
giftboxDrawer.classList.remove('open');
document.body.appendChild(giftboxDrawer);
currentGiftboxDrawer = giftboxDrawer;
ensureGiftboxBackdrop();
return giftboxDrawer;
};

/* Endast synlig på desktop: diskret fördelsrad i den vita ytan under bildgalleriet. */
const addDrawerBenefits = (root) => {
    const media = root?.querySelector('.mak__new__pdp-data > .mak_pdp-top_data');
    if (!media || media.querySelector('.mn-drawer-benefits')) return;
    media.insertAdjacentHTML('beforeend', '<div class="mn-drawer-benefits" aria-label="Fördelar med att handla hos oss">\n  <div class="mn-drawer-benefits__item">\n    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.65" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z"/><path d="m9 12 2 2 4-4"/></svg>\n    <span>Svenskt företag</span>\n  </div>\n  <div class="mn-drawer-benefits__item">\n    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.65" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 12v10H4V12"/><path d="M2 7h20v5H2z"/><path d="M12 22V7"/><path d="M12 7H7.5a2.5 2.5 0 1 1 2.5-2.5c0 2 2 2.5 2 2.5Z"/><path d="M12 7h4.5A2.5 2.5 0 1 0 14 4.5C14 6.5 12 7 12 7Z"/></svg>\n    <span>Personligt för dig</span>\n  </div>\n  <div class="mn-drawer-benefits__item">\n    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.65" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>\n    <span>Trygga betalningar</span>\n  </div>\n</div>');
};

const mountDrawerHtml = (html) => {
removePortaledGiftbox();
drawerContent.classList.add('is-loading');
drawerContent.classList.remove('is-loaded');
drawerContent.setAttribute('aria-busy', 'true');
drawerContent.innerHTML = html;
const remoteSection = drawerContent.querySelector(
'#shopify-section-collection-bundle-drawer'
);
if (remoteSection) {
const fragment = document.createDocumentFragment();
while (remoteSection.firstChild) {
fragment.appendChild(remoteSection.firstChild);
}
drawerContent.replaceChildren(fragment);
}
const productBottom =
drawerContent.querySelector('.mak_pdp-btm-data') ||
drawerContent.querySelector('.mak__new__pdp-data');
if (
productBottom &&
!productBottom.querySelector('.mn-drawer-keyboard-space')
) {
productBottom.insertAdjacentHTML(
'beforeend',
'<div class="mn-drawer-keyboard-space" aria-hidden="true"></div>'
);
}
const confirmButton = drawerContent.querySelector('.mak__atc-upsell');
if (confirmButton) {
confirmButton.setAttribute('type', 'button');
confirmButton.setAttribute('data-mn-builder-confirm', '');
confirmButton.querySelector('.btn__text')
? confirmButton.querySelector('.btn__text').textContent = 'Lägg till'
: confirmButton.textContent = 'Lägg till';

const upsellId = String(
confirmButton.dataset.upsellId ||
confirmButton.dataset.productId ||
''
).trim();

if (giftboxTemplate && upsellId) {
const giftboxFragment = giftboxTemplate.content.cloneNode(true);
const giftboxDrawer = giftboxFragment.querySelector('.mak__upsell-inner');
if (giftboxDrawer) {
giftboxDrawer.id = `new-drawer-upsell-${upsellId}`;
giftboxDrawer.dataset.pdpId = upsellId;
portalGiftboxDrawer(giftboxDrawer);
}
}
}
addDrawerBenefits(drawerContent);
initExistingCustomisation();
drawerContent.classList.remove('is-loading');
drawerContent.classList.remove('is-loaded');
drawerContent.setAttribute('aria-busy', 'false');
void drawerContent.offsetWidth;
drawerContent.classList.add('is-loaded');
};
const getFirstDrawerImageUrl = (html) => {
const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
const firstImage = parsedDocument.querySelector(
'.product-main-slider .main-pdp img, .banner-images-pdp img'
);
return (
firstImage?.getAttribute('src') ||
firstImage?.getAttribute('data-src') ||
firstImage?.getAttribute('srcset')?.split(',')[0]?.trim().split(' ')[0] ||
''
);
};
const warmFirstDrawerImage = (handle, html) => {
if (!handle || !html || drawerImageWarmCache.has(handle)) {
return Promise.resolve();
}
if (drawerImageWarmRequests.has(handle)) {
return drawerImageWarmRequests.get(handle);
}
const imageUrl = getFirstDrawerImageUrl(html);
if (!imageUrl) return Promise.resolve();
const request = new Promise((resolve) => {
const image = new Image();
let resolved = false;
const finish = () => {
if (resolved) return;
resolved = true;
drawerImageWarmCache.add(handle);
drawerImageWarmRequests.delete(handle);
resolve();
};
image.decoding = 'async';
image.fetchPriority = 'low';
image.onload = finish;
image.onerror = finish;
image.src = imageUrl;
if (image.complete) finish();
window.setTimeout(finish, 3000);
});
drawerImageWarmRequests.set(handle, request);
return request;
};
const fetchDrawerHtml = (handle, requestPriority = 'auto') => {
if (drawerCache.has(handle)) {
return Promise.resolve(drawerCache.get(handle));
}
if (drawerRequestCache.has(handle)) {
return drawerRequestCache.get(handle);
}
const request = (async () => {
const rootUrl = window.Shopify?.routes?.root || '/';
const url =
`${rootUrl}products/${encodeURIComponent(handle)}` +
'?section_id=collection-bundle-drawer';
const fetchOptions = {
credentials: 'same-origin',
headers: {
'X-Requested-With': 'XMLHttpRequest'
}
};
if (requestPriority !== 'auto') {
fetchOptions.priority = requestPriority;
}
const response = await fetch(url, fetchOptions);
if (!response.ok) {
throw new Error('Smycket kunde inte laddas.');
}
const html = await response.text();
if (!html.trim()) {
throw new Error('Smycket kunde inte laddas.');
}
drawerCache.set(handle, html);
return html;
})();
drawerRequestCache.set(handle, request);
request.then(
() => drawerRequestCache.delete(handle),
() => drawerRequestCache.delete(handle)
);
return request;
};
const loadDrawer = async (card, loadToken) => {
const handle = card.dataset.productHandle;
if (!handle) {
throw new Error('Produktens handle saknas.');
}
if (drawerCache.has(handle)) {
if (loadToken === drawerLoadToken && activeCard === card) {
mountDrawerHtml(drawerCache.get(handle));
}
return;
}
drawerContent.classList.add('is-loading');
drawerContent.classList.remove('is-loaded');
drawerContent.setAttribute('aria-busy', 'true');
drawerContent.innerHTML = drawerSkeletonHtml;
const html = await fetchDrawerHtml(handle, 'high');
if (
loadToken !== drawerLoadToken ||
activeCard !== card ||
!drawer.classList.contains('is-open')
) {
return;
}
mountDrawerHtml(html);
};
const showDrawer = async (button) => {
if (selectedItems.length >= bundleSize) return;
const card = button.closest('[data-mn-builder-card]');
if (!card) return;

const loadToken = ++drawerLoadToken;
activeCard = card;
drawer.classList.remove('mn-builder-drawer--settled');
/* Börja alltid högst upp när Anpassa-drawern öppnas igen.
   Panelen scrollar på mobil; på desktop har produktkolumnerna egen scroll. */
const drawerPanel = drawer.querySelector('.mn-builder-drawer__panel');
if (drawerPanel) drawerPanel.scrollTop = 0;
drawerContent.querySelectorAll('.mak_pdp-top_data, .mak_pdp-btm-data').forEach((column) => {
  column.scrollTop = 0;
});
/* Lås fast panelens stängda startposition innan is-open aktiverar slide.
   Utan en layout-läsning kan CSS-övergången hoppas över vid snabb öppning. */
void drawerPanel?.offsetWidth;
drawer.classList.add('is-open');
drawer.setAttribute('aria-hidden', 'false');
lockPage();

/* Låt slide-animationen bli klar, sedan släpp transform-lagret.
   Detta förhindrar suddig text vid browser-zoom. */
window.setTimeout(() => {
if (loadToken === drawerLoadToken && drawer.classList.contains('is-open')) {
drawer.classList.add('mn-builder-drawer--settled');
}
}, 500);

try {
await loadDrawer(card, loadToken);
} catch (error) {
if (
loadToken !== drawerLoadToken ||
activeCard !== card ||
!drawer.classList.contains('is-open')
) {
return;
}
drawerContent.innerHTML = `
<div class="mn-builder-drawer__load-error">
${escapeHtml(error.message || 'Smycket kunde inte laddas.')}
</div>
`;
drawerContent.classList.remove('is-loading');
drawerContent.classList.add('is-loaded');
drawerContent.setAttribute('aria-busy', 'false');
}
};
const getGiftboxDrawer = () => {
if (
currentGiftboxDrawer &&
document.body.contains(currentGiftboxDrawer)
) {
return currentGiftboxDrawer;
}
return null;
};

const getOpenGiftboxDrawer = () => {
const giftboxDrawer = getGiftboxDrawer();
return giftboxDrawer?.classList.contains('open')
? giftboxDrawer
: null;
};

const clearGiftboxError = () => {
drawerContent
.querySelectorAll('.mn-builder-giftbox-error')
.forEach((error) => error.remove());
getGiftboxDrawer()
?.querySelectorAll('.mn-builder-giftbox-error')
.forEach((error) => error.remove());
};

const showGiftboxError = (message, root = drawerContent) => {
clearGiftboxError();
const error = document.createElement('p');
error.className = 'mn-builder-giftbox-error';
error.textContent = message;
(root || drawerContent).appendChild(error);
};

const closeGiftboxDrawer = (instant = false) => {
const giftboxDrawer = getOpenGiftboxDrawer() || getGiftboxDrawer();
if (!giftboxDrawer) return;
const backdrop = ensureGiftboxBackdrop();
/* Vid överlämning till varukorgen: dölj bakomliggande presentförpackning
   direkt, utan att dess utgående slide syns efter att cart drawer öppnats. */
if (instant) {
giftboxDrawer.style.setProperty('transition', 'none', 'important');
backdrop.style.setProperty('transition', 'none', 'important');
}
giftboxDrawer.classList.remove('open');
giftboxDrawer.setAttribute('aria-hidden', 'true');
document.body.classList.remove('mn-builder-giftbox-open');
backdrop.classList.remove('is-open');
const finish = () => {
giftboxDrawer.scrollTop = 0;
};
if (instant) {
finish();
/* Tvinga webbläsaren att tillämpa det stängda läget innan vi återställer
   övergången, så nästa öppning fortfarande får sin vanliga slide. */
void giftboxDrawer.offsetWidth;
void backdrop.offsetWidth;
window.requestAnimationFrame(() => {
if (!giftboxDrawer.classList.contains('open')) giftboxDrawer.style.removeProperty('transition');
if (!backdrop.classList.contains('is-open')) backdrop.style.removeProperty('transition');
});
} else window.setTimeout(finish, 300);
};

const openGiftboxDrawer = () => {
const giftboxDrawer = getGiftboxDrawer();
if (!giftboxDrawer) {
showGiftboxError(
'Ingen presentförpackning är vald. Välj en produkt under “Giftbox upsell product” i sektionsinställningarna.'
);
return false;
}
clearGiftboxError();
const backdrop = ensureGiftboxBackdrop();
giftboxDrawer.setAttribute('aria-hidden', 'false');
giftboxDrawer.scrollTop = 0;
void giftboxDrawer.offsetWidth;
document.body.classList.add('mn-builder-giftbox-open');
backdrop.classList.add('is-open');
giftboxDrawer.classList.add('open');
return true;
};

const rollbackThirdSelection = () => {
  /* Keep the finished bundle if the user backs out of the giftbox upsell. */
  closeGiftboxDrawer(false);
  clearGiftboxError();
};

const hideDrawer = (instant = false, options = {}) => {
drawerContent.querySelectorAll('.product-main-slider video').forEach((video) => {
  if (!video.paused) video.pause();
});
drawerLoadToken += 1;
drawer.classList.remove('mn-builder-drawer--settled');
if (
!bundleCartInProgress &&
getOpenGiftboxDrawer() &&
selectedItems.length === bundleSize
) {
selectedItems.pop();
updateSlots();
}
closeGiftboxDrawer(true);
clearGiftboxError();
if (
document.activeElement &&
drawer.contains(document.activeElement)
) {
document.activeElement.blur();
}
if (instant) {
drawer.classList.add('mn-builder-drawer--instant-close');
}
drawer.classList.remove('is-open');
drawer.setAttribute('aria-hidden', 'true');
activeCard = null;
if (!options.skipUnlock) unlockPage();
if (instant) {
window.requestAnimationFrame(() => {
drawer.classList.remove('mn-builder-drawer--instant-close');
});
}
};
const getPreloadProfile = () => {
const connection =
navigator.connection ||
navigator.mozConnection ||
navigator.webkitConnection;
const effectiveType = String(connection?.effectiveType || '').toLowerCase();
const saveData = Boolean(connection?.saveData);
if (saveData || effectiveType === 'slow-2g' || effectiveType === '2g') {
return {
drawerCount: 0,
imageCount: 0,
startDelay: 0
};
}
if (effectiveType === '3g') {
return {
drawerCount: 1,
imageCount: 1,
startDelay: 2400
};
}
return {
drawerCount: 4,
imageCount: 2,
startDelay: 1400
};
};
const waitUntilVisible = () => {
if (document.visibilityState === 'visible') {
return Promise.resolve();
}
return new Promise((resolve) => {
const onVisibilityChange = () => {
if (document.visibilityState !== 'visible') return;
document.removeEventListener('visibilitychange', onVisibilityChange);
resolve();
};
document.addEventListener('visibilitychange', onVisibilityChange);
});
};
const waitForIdle = (timeout = 2200) =>
new Promise((resolve) => {
if ('requestIdleCallback' in window) {
window.requestIdleCallback(() => resolve(), { timeout });
} else {
window.setTimeout(resolve, 300);
}
});
const waitForDrawerToClose = async () => {
while (drawer.classList.contains('is-open')) {
await new Promise((resolve) => window.setTimeout(resolve, 350));
}
};
const preloadPriorityDrawers = async (profile) => {
const priorityCards = [...sectionRoot.querySelectorAll(
'[data-mn-builder-card][data-product-handle]'
)].slice(0, profile.drawerCount);
for (let index = 0; index < priorityCards.length; index += 1) {
const card = priorityCards[index];
const handle = card.dataset.productHandle;
if (!handle) continue;
await waitUntilVisible();
await waitForDrawerToClose();
await waitForIdle(index === 0 ? 1800 : 2800);
try {
const html = await fetchDrawerHtml(handle, 'low');
if (index < profile.imageCount) {
await warmFirstDrawerImage(handle, html);
}
} catch (error) {
}
await new Promise((resolve) => window.setTimeout(resolve, 180));
}
};
let priorityPreloadScheduled = false;
const schedulePriorityPreload = () => {
if (priorityPreloadScheduled) return;
priorityPreloadScheduled = true;
const profile = getPreloadProfile();
if (!profile.drawerCount) return;
window.setTimeout(() => {
waitUntilVisible()
.then(() => waitForIdle(2600))
.then(() => preloadPriorityDrawers(profile))
.catch(() => {});
}, profile.startDelay);
};
const swapCardButtonLabel = (cardButton, labelHtml, isAdded) => {
if (!cardButton) return;
let label = cardButton.querySelector('.mn-builder-card__button-label');
if (!label) {
label = document.createElement('span');
label.className = 'mn-builder-card__button-label';
label.innerHTML = cardButton.innerHTML;
cardButton.replaceChildren(label);
}
if (cardButton.mnLabelSwapTimer) {
window.clearTimeout(cardButton.mnLabelSwapTimer);
}
cardButton.classList.add('is-label-hidden');
cardButton.mnLabelSwapTimer = window.setTimeout(() => {
label.innerHTML = labelHtml;
cardButton.classList.toggle('is-added', isAdded);
cardButton.classList.toggle('is-just-added', isAdded);
window.requestAnimationFrame(() => {
cardButton.classList.remove('is-label-hidden');
});
cardButton.mnLabelSwapTimer = null;
}, 140);
};
const animateCardAdded = (card) => {
/* Mobil: behåll knappens vanliga text utan ✓ Tillagd-animationen. */
if (window.matchMedia('(max-width: 768px)').matches) return;
const cardButton = card?.querySelector('.mn-builder-card__button');
if (!cardButton || cardButton.disabled) return;
if (cardButton.mnAddedTimer) {
window.clearTimeout(cardButton.mnAddedTimer);
}
swapCardButtonLabel(
cardButton,
'<span class="mn-added-checkmark" aria-hidden="true">✓</span><span>Tillagd</span>',
true
);
cardButton.mnAddedTimer = window.setTimeout(() => {
swapCardButtonLabel(cardButton, 'Välj +', false);
cardButton.mnAddedTimer = null;
}, 2000);
};
const getDrawerImageUrl = (imageElement) => {
if (!imageElement) return '';
return (
imageElement.currentSrc ||
imageElement.getAttribute('src') ||
imageElement.getAttribute('data-src') ||
imageElement.getAttribute('srcset')?.split(',')[0]?.trim().split(' ')[0] ||
''
);
};
const getSelectedVariantThumbnail = (productRoot, variantId, variant = {}) => {
if (!productRoot) return variant.image || '';

const masterSelect = productRoot.querySelector(
'.mak__variants-main select[name="id"], select[name="id"]'
);
const selectedOption = masterSelect
? [...masterSelect.options].find(
(option) => String(option.value) === String(variantId)
) || masterSelect.selectedOptions?.[0]
: null;

/* Läs bild-id direkt från det valda alternativet/swatchen först.
   Då får t.ex. silver sin silverbild i Ditt paket i stället för
   produktkortets standardbild (som ofta är guld). */
const checkedInputs = [...productRoot.querySelectorAll(
'.mak__variants-main .mak_variants_radio:checked, .mak__variants-main input[type="radio"]:checked'
)];
const selectedImageId =
selectedOption?.getAttribute('data-image-id') ||
selectedOption?.dataset?.imageId ||
checkedInputs
.map((input) => input.getAttribute('data-image-id') || input.dataset?.imageId || '')
.find(Boolean) ||
variant.mediaId ||
variant.imageId ||
'';

if (selectedImageId) {
const matchingSlide = [...productRoot.querySelectorAll(
'.product-main-slider .main-pdp:not(.slick-cloned)'
)].find((slide) =>
String(
slide.getAttribute('data-image-id') ||
slide.getAttribute('data-media-id') ||
''
) === String(selectedImageId)
);
const matchingImageUrl = getDrawerImageUrl(matchingSlide?.querySelector('img'));
if (matchingImageUrl) return matchingImageUrl;
}

/* Om varianten redan innehåller en egen bild använder vi den före produktkortets
   standardbild. */
if (variant.image) return variant.image;

/* Sista drawer-fallback: bilden som för närvarande visas i huvudslidern. */
const currentSlide =
productRoot.querySelector(
'.product-main-slider .main-pdp.slick-current:not(.slick-cloned)'
) ||
productRoot.querySelector('.product-main-slider .main-pdp:not(.slick-cloned)');
const currentImageUrl = getDrawerImageUrl(currentSlide?.querySelector('img'));
if (currentImageUrl) return currentImageUrl;

return '';
};
/* Main Collection: uppdatera teckenräknaren på det SYNLIGA namnfältet.
   Temats globala textLimit() lyssnar annars på #maktextInput, som är ett
   dolt fält för vissa produkter. Kör även vid dynamiskt drawer-innehåll. */
const updateCollectionNameCounter = (input) => {
  if (!input || input.type === 'hidden') return;
  const field = input.closest('.mak-iec-inner-text-wrapper');
  const counter = field?.querySelector('#mak_font-limit');
  if (!counter) return;
  const max = input.maxLength > 0 ? input.maxLength : 6;
  counter.textContent = `${input.value.length}/${max}`;
};
const initCollectionNameCounters = () => {
  drawerContent.querySelectorAll('.mak-iec-inner-text-wrapper').forEach((field) => {
    const input = field.querySelector(
      '#personalization-field, .free-font-text, #personalizationInput, #maktextInput:not([type="hidden"]), #textInput:not([type="hidden"])'
    );
    updateCollectionNameCounter(input);
  });
};
drawerContent.addEventListener('input', (event) => {
  if (event.target.matches('#personalization-field, .free-font-text, #personalizationInput, #maktextInput, #textInput')) {
    updateCollectionNameCounter(event.target);
  }
}, true);

/* Main Collection hämtar produktens formulär dynamiskt. Skriven text måste
   synkas till de dolda fälten som temats befintliga validering kontrollerar. */
const syncCollectionDrawerNameFields = () => {
  drawerContent.querySelectorAll('.mak-input-wrapper').forEach((wrapper) => {
    const simpleInput = wrapper.querySelector('#personalizationInput');
    if (simpleInput) {
      const hiddenInput = wrapper.querySelector('#maktextInput');
      const savedInput = wrapper.querySelector('#maktextInput-val');
      if (hiddenInput?.type === 'hidden') hiddenInput.value = simpleInput.value;
      if (savedInput) savedInput.value = simpleInput.value;
      if (simpleInput.value.trim()) {
        const error = wrapper.querySelector('#name-error1');
        if (error) error.style.display = 'none';
      }
    }

    const nameInput = wrapper.querySelector('#personalization-field');
    if (nameInput) {
      const hiddenInput = wrapper.querySelector('#your-name');
      if (hiddenInput?.type === 'hidden') hiddenInput.value = nameInput.value;
      if (nameInput.value.trim()) {
        const error = wrapper.querySelector('#name-error2');
        if (error) error.style.display = 'none';
      }
    }
  });
};

drawerContent.addEventListener('input', (event) => {
  if (event.target.matches('#personalizationInput, #personalization-field')) {
    syncCollectionDrawerNameFields();
  }
}, true);

const selectCurrentProduct = (button) => {
if (!activeCard || selectedItems.length >= bundleSize) return;
syncCollectionDrawerNameFields();
if (
typeof window.makValidateFreeProductDrawer === 'function' &&
!window.makValidateFreeProductDrawer(drawer)
) {
return;
}
if (typeof window.makCollectFreeProductItemFromDrawer !== 'function') {
showGiftboxError('Smycket kunde inte läsas in. Ladda om sidan och prova igen.');
return;
}
const cartItem = window.makCollectFreeProductItemFromDrawer(
drawer,
button
);
if (!cartItem?.id) {
showGiftboxError('Smycket kunde inte läggas till. Kontrollera dina val.');
return;
}
const variantMap = readVariantMap();
const variant = variantMap[String(cartItem.id)] || {};
const title = activeCard.dataset.productTitle || '';
const productRoot =
drawerContent.querySelector('.mak__new__pdp-data') ||
drawerContent;
const premiumSlotTitle = getPremiumSlotTitle(
productRoot,
cartItem.id,
variant
);
const enteredName = getFirstName(cartItem.properties);
const bundleName = enteredName || (
!hasBundleNameField(productRoot)
? getBundleVariantName(productRoot, cartItem.id, variant)
: ''
);
const bundleOption = getBundleSelectedOption(
productRoot,
cartItem.id,
variant
);
/* Ditt paket: bokstavshalsband med A–Ö ska visa "Bokstav:" i stället för "Namn:". */
const propertyLabel = /^[A-ZÅÄÖ]$/i.test(String(bundleName || '').trim()) && !hasBundleNameField(productRoot)
? 'Bokstav'
: 'Namn';
selectedItems.push({
variantId: Number(cartItem.id),
properties: cartItem.properties || {},
title,
image: getSelectedVariantThumbnail(productRoot, cartItem.id, variant) || activeCard.dataset.productImage || '',
property: bundleName,
propertyLabel,
option: bundleOption,
slotTitle: premiumSlotTitle || formatTitle(title)
});
const selectedCard = activeCard;
updateSlots();

/* Both desktop and mobile use an explicit package CTA before the giftbox. */
const hasPackageButton = (Boolean(desktopPackageCta) && window.matchMedia('(min-width: 1000px)').matches) ||
  (Boolean(mobilePackageCta) && window.matchMedia('(max-width: 999px)').matches);
if (selectedItems.length < bundleSize) {
animateCardAdded(selectedCard);
}

if (selectedItems.length < bundleSize || hasPackageButton) {
/* Avbryt inte shoppingflödet: stäng Anpassa-drawern efter valet. */
hideDrawer(true);

return;
}

if (!openGiftboxDrawer()) {
selectedItems.pop();
updateSlots();
}
};

const setBundleActionLoading = (button, loading) => {
if (!button) return;
button.disabled = loading;
button.classList.toggle('is-loading', loading);
};

const addBundleToCart = async (giftboxItem = null, actionButton = null) => {
if (selectedItems.length !== bundleSize || bundleCartInProgress) return;
bundleCartInProgress = true;
const loadingStartedAt = performance.now();
setBundleActionLoading(actionButton, true);
clearGiftboxError();
try {
const rootUrl = window.Shopify?.routes?.root || '/';
const items = selectedItems.map((item) => ({
id: item.variantId,
quantity: 1,
properties: item.properties
}));
if (giftboxItem?.id) items.push(giftboxItem);
const response = await fetch(`${rootUrl}cart/add.js`, {
method: 'POST',
headers: {
'Content-Type': 'application/json',
Accept: 'application/json'
},
body: JSON.stringify({ items })
});
if (!response.ok) {
const responseData = await response.json().catch(() => ({}));
throw new Error(
responseData.description ||
responseData.message ||
'Produkterna kunde inte läggas i varukorgen.'
);
}
/* Låt både Anpassa- och giftbox-drawern ligga kvar under cart-refresh,
   och behåll spinnern minst 500 ms. Cart drawer öppnas ovanpå dem. */
const cartDrawer = document.querySelector('cart-drawer');
const cartForm =
cartDrawer?.querySelector('cart-form') ||
document.querySelector('cart-form');

if (cartForm?.refresh) {
try {
await cartForm.refresh({ suppressDrawerOpen: true });
} catch (refreshError) {
console.error('Cart drawer refresh failed:', refreshError);
}
}

/* Uppdatera även headerns varukorgsbubbla utan att starta en ny cart drawer-refresh. */
document.querySelector('page-header')?.refreshHeader?.();

const remainingLoadingTime = Math.max(0, 500 - (performance.now() - loadingStartedAt));
if (remainingLoadingTime) {
await new Promise((resolve) => window.setTimeout(resolve, remainingLoadingTime));
}

if (!cartDrawer) throw new Error('Varukorgen kunde inte öppnas.');

const desktopCartHandoff = window.matchMedia('(min-width: 769px)').matches;
const finishBundleCartHandoff = () => {
/* Efter cart-drawerns after-open-händelse: behåll giftboxen öppen
   bakom den nya varukorgen i ytterligare 500 ms på mobil.
   after-open kan skickas innan öppningsanimationen är synligt klar. */
window.setTimeout(() => {
if (!desktopCartHandoff) closeGiftboxDrawer(true);
selectedItems.splice(0, selectedItems.length);
updateSlots();
hideDrawer(true, { skipUnlock: true });
setBundleActionLoading(actionButton, false);
bundleCartInProgress = false;
}, 500);
};

/* Desktop: stäng giftboxen direkt innan varukorgen börjar öppnas.
   Mobil: behåll den bakom varukorgen och stäng den efter öppningen.
   Behåll cart-handoff-lagret i båda fallen för övriga drawers. */
if (desktopCartHandoff) closeGiftboxDrawer(true);
document.body.classList.add('mn-collection-cart-handoff');
const releaseCartLayer = (event) => {
if (event.target !== cartDrawer) return;
cartDrawer.removeEventListener('on:cart-drawer:after-close', releaseCartLayer);
document.body.classList.remove('mn-collection-cart-handoff');
};
cartDrawer.addEventListener('on:cart-drawer:after-close', releaseCartLayer);

/* Lämna över sidans scroll-lock till Symmetry utan att stänga drawern. */
unlockPage();
if (cartDrawer.hasAttribute('open')) {
finishBundleCartHandoff();
} else {
const afterCartOpen = (event) => {
if (event.target !== cartDrawer) return;
document.removeEventListener('on:cart-drawer:after-open', afterCartOpen);
finishBundleCartHandoff();
};
document.addEventListener('on:cart-drawer:after-open', afterCartOpen);
/* Kör Symmetry-cartdrawerns eget open() och dess ursprungliga
   transform-animation; sätt INTE transform: none/0 i JavaScript. */
document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
}
} catch (error) {
showGiftboxError(
error.message || 'Produkterna kunde inte läggas i varukorgen.',
getOpenGiftboxDrawer() || drawerContent
);
setBundleActionLoading(actionButton, false);
bundleCartInProgress = false;
}
};

// Capture den fristående giftbox-drawerns klick före main.js/free-products.
document.addEventListener('click', (event) => {
const giftboxDrawer = event.target.closest(
'.mak__upsell-inner.side-drawer-upsell[data-mn-builder-giftbox]'
);
if (!giftboxDrawer || giftboxDrawer !== getGiftboxDrawer()) return;

const backButton = event.target.closest(
'.side-drawer-header-upsell .side-pdp-close-upsell'
);
if (backButton) {
event.preventDefault();
event.stopPropagation();
event.stopImmediatePropagation();
rollbackThirdSelection();
return;
}

const giftboxYesButton = event.target.closest(
'.mak__atc-upsell-final, #upsell__atc-final'
);
if (giftboxYesButton) {
event.preventDefault();
event.stopPropagation();
event.stopImmediatePropagation();
const giftboxRoot = giftboxYesButton.closest('.upsell-popup-data');
const giftboxId = Number(
giftboxYesButton.dataset.upsellVariantId ||
giftboxRoot?.dataset.id
);
const quantity = Math.max(
1,
Number(
giftboxYesButton
.closest('.mak_upsell-container')
?.querySelector('.mak-quantity-input')
?.value || 1
)
);
if (!giftboxId) {
showGiftboxError(
'Presentförpackningen kunde inte läggas till.',
giftboxDrawer
);
return;
}
addBundleToCart(
{ id: giftboxId, quantity },
giftboxYesButton
);
return;
}

const giftboxNoButton = event.target.closest(
'.mak__atc-final, #final__atc'
);
if (giftboxNoButton) {
event.preventDefault();
event.stopPropagation();
event.stopImmediatePropagation();
addBundleToCart(null, giftboxNoButton);
}
}, true);

// Capture Anpassa ditt smycke-knappen före main.js/free-products.
drawerContent.addEventListener('click', (event) => {
const confirmButton = event.target.closest(
'.mak__atc-upsell, [data-mn-builder-confirm]'
);
if (!confirmButton) return;
event.preventDefault();
event.stopPropagation();
event.stopImmediatePropagation();
selectCurrentProduct(confirmButton);
}, true);
sectionRoot.addEventListener('click', (event) => {
const packageAction = event.target.closest('[data-mn-desktop-package-cta], [data-mn-mobile-package-cta]');
if (packageAction) {
  event.preventDefault();
  const desktopAction = packageAction.hasAttribute('data-mn-desktop-package-cta');
  const correctViewport = desktopAction
    ? window.matchMedia('(min-width: 1000px)').matches
    : window.matchMedia('(max-width: 999px)').matches;
  if (!correctViewport || packageAction.disabled || bundleCartInProgress ||
      selectedItems.length !== bundleSize || getOpenGiftboxDrawer()) return;
  openGiftboxDrawer();
  return;
}
const scrollButton = event.target.closest('[data-mn-builder-scroll]');
if (scrollButton) {
event.preventDefault();

/* In the sticky mobile bar, '+' goes directly to the product cards.
   No floating modal is involved. */
if (scrollButton.closest('[data-mn-mobile-dock]') && productsGrid) {
const headerOffset = [...document.querySelectorAll(
  'sticky-header, .shopify-section-header-sticky, .section-header, [data-sticky-header], header'
)].reduce((bottom, element) => {
  const rect = element.getBoundingClientRect();
  const style = window.getComputedStyle(element);
  return rect.height > 0 && rect.bottom > 0 && rect.top <= 5 &&
    (style.position === 'sticky' || style.position === 'fixed')
    ? Math.max(bottom, Math.ceil(rect.bottom)) : bottom;
}, 0);
window.scrollTo({
  top: Math.max(0, Math.round(window.scrollY + productsGrid.getBoundingClientRect().top - headerOffset - 8)),
  behavior: 'smooth'
});
return;
}

const isMobile = window.matchMedia('(max-width: 768px)').matches;
const isDesktop = window.matchMedia('(min-width: 1000px)').matches;

/* Desktop: sidopanelens tomma smyckesplatser ska leda till produktgriden.
   På mobil används den befintliga paket-scrollningen oförändrat. */
if (isDesktop && scrollButton.closest('[data-mn-desktop-package-wrap]') && productsGrid) {
  const stickyHeaderBottom = [...document.querySelectorAll(
    'sticky-header, .shopify-section-header-sticky, .section-header, [data-sticky-header], header'
  )].reduce((bottom, element) => {
    const rect = element.getBoundingClientRect();
    const style = window.getComputedStyle(element);
    return rect.height > 0 && rect.bottom > 0 && rect.top <= 5 &&
      (style.position === 'sticky' || style.position === 'fixed')
      ? Math.max(bottom, Math.ceil(rect.bottom)) : bottom;
  }, 0);
  const gridTop = Math.max(0, Math.round(window.scrollY + productsGrid.getBoundingClientRect().top - stickyHeaderBottom - 12));
  if (window.scrollY < gridTop || window.scrollY > gridTop + 180) {
    window.scrollTo({ top: gridTop, behavior: 'smooth' });
  }
  return;
}

/* Nedersta paketets Välj-knappar tar kunden tillbaka till produktgriden.
   Den översta paketsektionens befintliga scrollbeteende påverkas inte. */
if (scrollButton.closest('[data-mn-inline-package-wrap-bottom]') && !scrollButton.hasAttribute('data-mn-bottom-package-cta') && productsGrid) {
const stickyHeaderBottom = [...document.querySelectorAll(
'sticky-header, .shopify-section-header-sticky, .section-header, [data-sticky-header], header'
)].reduce((bottom, element) => {
const rect = element.getBoundingClientRect();
const style = window.getComputedStyle(element);
return rect.height > 0 && rect.bottom > 0 && rect.top <= 5 &&
(style.position === 'sticky' || style.position === 'fixed')
? Math.max(bottom, Math.ceil(rect.bottom)) : bottom;
}, 0);
window.scrollTo({
top: Math.max(0, Math.round(window.scrollY + productsGrid.getBoundingClientRect().top - stickyHeaderBottom - 8)),
behavior: 'smooth'
});
return;
}

const isHeroOrInlinePackage = Boolean(
scrollButton.closest('.mn-bundle-hero') ||
scrollButton.hasAttribute('data-mn-bottom-package-cta') ||
scrollButton.closest('[data-mn-inline-package-wrap]')
);

/* Mobil: hero-CTA:n och alla Välj-knappar i Ditt paket ska landa på
   exakt samma ställe. UNDERKANTEN på sista kortet (Gratis smycke) placeras
   direkt vid nederkanten på den sticky/fixed header som faktiskt syns. */
if (isMobile && inlinePackageWrap && isHeroOrInlinePackage) {
const lastPackageSlot = inlinePackage?.querySelector(
'.mn-bundle-package__list > :last-child'
);

if (lastPackageSlot) {
const stickyHeaderBottom = [...document.querySelectorAll(
'sticky-header, .shopify-section-header-sticky, .section-header, [data-sticky-header], header'
)].reduce((bottom, element) => {
const rect = element.getBoundingClientRect();
const style = window.getComputedStyle(element);

if (
rect.height > 0 &&
rect.bottom > 0 &&
rect.top <= 5 &&
(style.position === 'sticky' || style.position === 'fixed')
) {
return Math.max(bottom, Math.ceil(rect.bottom));
}

return bottom;
}, 0);

const targetTop =
window.scrollY +
lastPackageSlot.getBoundingClientRect().bottom -
stickyHeaderBottom +
3;

window.scrollTo({
top: Math.max(0, Math.round(targetTop)),
behavior: 'smooth'
});
return;
}
}

/* Desktop: behåll tidigare beteende där paketsektionens överkant hamnar
   direkt under sticky header. */
const shouldStopBelowHero =
isDesktop &&
inlinePackageWrap &&
isHeroOrInlinePackage &&
!sectionRoot.querySelector('[data-mn-desktop-package-wrap]');

if (shouldStopBelowHero) {
const stickyHeaderBottom = [...document.querySelectorAll(
'sticky-header, .shopify-section-header-sticky, .section-header, [data-sticky-header], header'
)].reduce((bottom, element) => {
const rect = element.getBoundingClientRect();
const style = window.getComputedStyle(element);

if (
rect.height > 0 &&
rect.bottom > 0 &&
rect.top <= 5 &&
(style.position === 'sticky' || style.position === 'fixed')
) {
return Math.max(bottom, Math.ceil(rect.bottom));
}

return bottom;
}, 0);

window.scrollTo({
top:
inlinePackageWrap.getBoundingClientRect().top +
window.scrollY -
stickyHeaderBottom,
behavior: 'smooth'
});
} else {
builder.scrollIntoView({ behavior: 'smooth', block: 'start' });
}
return;
}
const openButton = event.target.closest('[data-mn-builder-open]');
if (openButton) {
event.preventDefault();
showDrawer(openButton);
return;
}
if (event.target.closest('[data-mn-builder-close]')) {
event.preventDefault();
hideDrawer();
return;
}
const removeButton = event.target.closest('[data-mn-builder-remove]');
if (removeButton) {
selectedItems.splice(Number(removeButton.dataset.mnBuilderRemove), 1);
updateSlots();
return;
}
});

document.addEventListener('keydown', (event) => {
if (event.key !== 'Escape' || !drawer.classList.contains('is-open')) return;
if (getOpenGiftboxDrawer()) {
rollbackThirdSelection();
return;
}
hideDrawer();
});
syncDesktopGridGutters();
updateSlots();
if (document.readyState === 'complete') {
schedulePriorityPreload();
} else {
window.addEventListener('load', schedulePriorityPreload, { once: true });
}
})();
